<div class="scroll-progress-container">
  <div class="scroll-progress-bar" id="scroll-progress-bar"></div>
</div>
@if (currentBlog) {
  <div class="outer-container animated fadeIn">
    <div class="container" scrollProgress>
      <nav class="back-btn">
        <div class="nav_container">
          <div class="back_button" (click)="onBackBtnPress()">
            <mat-icon> keyboard_arrow_left</mat-icon>
            <p>{{ 'GENERAL.BACK' | translate }}</p>
          </div>
        </div>
      </nav>

      <div class="sub-container">
        <div class="post-content" [attr.id]="currentBlog.id">
          <div class="data-content">
            <h1 id="post-title">{{ currentBlog.title }}</h1>
            <div class="time_author">
              <p class="date">
                <time [dateTime]="currentBlog.publish_date || currentBlog.date">
                  {{
                    currentBlog.publish_date || currentBlog.date
                      | date: 'd. MMM, YYYY'
                  }}
                </time>
              </p>
              <span
                >af
                <a class="author" rel="author" routerLink="/skribent/saxo"
                  >Saxo Agdestein</a
                >
              </span>
            </div>

            <div class="img_container">
              <div class="breadcrumb_container">
                <app-breadcrumb-list
                  [dark_backdrop]="true"
                  [partsOfUrl]="partsOfUrl"
                  [transparent]="false"
                  [standard_max_width]="false"
                >
                </app-breadcrumb-list>
              </div>
              @if (currentBlog.imgUrl) {
                <img
                  [ngSrc]="currentBlog.imgUrl"
                  [alt]="currentBlog.title"
                  priority="true"
                  height="460"
                  width="100"
                  class="featured-img"
                />
              }
            </div>

            <div class="outer_body_container">
              <nav
                class="table_of_content"
                [class.accordionView]="innerWidth < 990"
              >
                @if (innerWidth < 990) {
                  <div
                    (click)="expandTableOfContent()"
                    class="expand_table_of_content"
                  >
                    <h2 class="mobile_h2">
                      {{ 'PLACEHOLDERS.I' | translate }}
                    </h2>
                    <mat-icon>{{
                      tableOfContentExpanded ? 'expand_less' : 'expand_more'
                    }}</mat-icon>
                  </div>
                }

                <div
                  class="content_of_table"
                  [class.isExpanded]="tableOfContentExpanded"
                >
                  <ul
                    class="content_table"
                    [class.isExpanded]="tableOfContentExpanded"
                  >
                    @if (innerWidth > 990) {
                      <h2 style="font-size: 20px; padding-top: 0 !important">
                        {{ 'PLACEHOLDERS.I' | translate }}
                      </h2>
                    }
                    @for (h2 of h2Texts; track h2.id) {
                      <li class="item">
                        <a
                          class="item"
                          (click)="scrollTo($event, h2.id)"
                          [href]="'#' + h2.id"
                        >
                          {{ h2.text }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </nav>

              <div>
                <section
                  class="text content_from_mongo"
                  id="content-text"
                  [innerHTML]="
                    currentBlog.content?.rich_text || currentBlog.content
                      | safe: 'html'
                  "
                ></section>

                @if (currentBlog?.content?.FAQ_area?.length > 1) {
                  <section
                    class="page-faqs"
                    itemscope
                    itemtype="https://schema.org/FAQPage"
                  >
                    <h2 class="title">{{ 'COMPONENTS.FAQ.Q3' | translate }}</h2>
                    <ul class="faq-list">
                      @for (
                        faq of currentBlog.content?.FAQ_area;
                        track faq?.id
                      ) {
                        <li
                          class="faq-list-item"
                          itemscope
                          itemprop="mainEntity"
                          itemtype="https://schema.org/Question"
                        >
                          <input
                            class="faq-list-item__toggle"
                            type="checkbox"
                            [checked]="true"
                            [id]="'faq' + $index"
                          />
                          <label
                            [for]="'faq' + $index"
                            class="faq-list-item__title"
                            itemprop="name"
                          >
                            <h3>{{ faq?.TITLE }}</h3>
                          </label>
                          <div
                            class="faq-list-item__answer"
                            itemscope
                            itemprop="acceptedAnswer"
                            itemtype="https://schema.org/Answer"
                          >
                            <span itemprop="text">
                              @if (faq?.TEXT != null) {
                                <p [innerHTML]="faq.TEXT | safe: 'html'"></p>
                              }
                            </span>
                          </div>
                        </li>
                      }
                    </ul>
                  </section>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (otherBlogs.length > 0) {
        <section class="other_blogs_wrapper">
          <div class="other-blogs-headline">
            <h2 style="text-align: center">
              {{ 'PLACEHOLDERS.REL_ART' | translate }} {{ currentBlogCategory }}
            </h2>
          </div>
          <div class="other-blogs">
            @for (blog of otherBlogs; track blog._id) {
              <article class="blog-card">
                <a [href]="generateLink(blog)">
                  <img
                    [ngSrc]="blog.imgUrl || defaultImage"
                    [alt]="blog.title"
                    [height]="CARD_HEIGHT"
                    [width]="CARD_WIDTH"
                    id="other-blog-img"
                  />
                  <div class="text">
                    <h3>{{ blog.title }}</h3>
                    <p [innerHTML]="blog.excerpt | safe: 'html'"></p>
                  </div>
                </a>
              </article>
            }
          </div>
        </section>
      }
      <app-lp-footer></app-lp-footer>
    </div>
  </div>
}

@if (breadCrumbSchema) {
  <div [innerHTML]="breadCrumbSchema | jsonLd"></div>
}
